<template>
  <div>
    <div class="login">
      <div class="container">
        <div class="logo">
          <a href="#" class="logo-link">
            <img src="/static/images/torepi-logo.png" alt="" class="mb-4 logo-img">
          </a>
        </div>
        <div class="login-box">
          <div class="title-box resetPass">
            <h2 class="pri-title">パスワード再設定</h2>
            <p class="sub-title">
              パスワード再設定のため
              <br />メールアドレスを入力してください。
            </p>
          </div>
          <form class="login-box--form" @submit.prevent="resetPassword">
            <div class="form-group">
              <label for="email" class="label-form">メールアドレス<span class="required">*</span></label>
              <div class="input-group">
                <input
                  id="email"
                  type="email"
                  name="email"
                  class="input-form"
                  placeholder="メールアドレスを入力してください"
                  v-model.trim="params.email"
                  :class="emailFormat()" @input="$v.params.email.$touch()"
                />
                <small v-if="!$v.params.email.required && invalid" class="text-input error">{{message.EMAIL_REQUIRED}}</small>
                <small v-if="!$v.params.email.valid && invalid && $v.params.email.required" class="text-input error">{{message.EMAIL_FORMAT}}</small>
                <small v-if="emailError()" class="text-input error">{{validateEmail(errorEmailReset[0])}}</small>
              </div>
            </div>
            <div class="button-group">
              <button
                class="btn btn-rounder btn-primary btn-login"
                type="button"
                @click="resetPassword"
              >送信</button>
            </div>
            <div class="form-footer text-center">
              <p class="text">すでにアカウントをお持ちですか？ <a class="link"><router-link :to="{name: 'login'}">ここでログイン。</router-link></a></p>
            </div>
          </form>
        </div>
        <div class="copyright">
          <span>株式会社SOFTNEXT©2020 All rights reserved</span>
        </div>
      </div>
      <div class="modalResetPass">
        <b-modal id="modal-center" ref="my-modal" modal-class="modalsmall" centered no-close-on-backdrop>
          <template v-slot:modal-header>
            <!-- Emulate built in modal header close button action -->
            <div class="title-modal text-center w-100">
              <h2 class="title">通知</h2>
              <p class="sub-title">
                メールが送信されました。
                <br />メールボックスを確認してください。
              </p>
            </div>
          </template>
            <div class="modal-img">
              <img src="static/images/email-success.svg" alt class="img-modal" />
            </div>
          <template v-slot:modal-footer>
            <div class="w-100 button-group">
              <button
                class="btn btn-rounder btn-primary btn-login"
                @click="back"
                type="button"
              >確認</button>
            </div>
          </template>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import { BModal, VBModal } from 'bootstrap-vue'
import {mapState} from 'vuex'
import errorMessage from '../../utils/errormessage'
import {required} from 'vuelidate/lib/validators'
import {MESSAGE} from '@/utils/errorjapanese'

export default {
  name: 'ResetPassword',
  components: {
    'b-modal': BModal
  },
  directives: {
    // Note that Vue automatically prefixes directive names with `v-`
    'b-modal': VBModal
  },
  data () {
    return {
      params: {
        email: ''
      },
      invalid: false,
      message: MESSAGE
    }
  },
  validations: {
    params: {
      email: {
        required,
        valid (email) {
          const validate = /^[[a-zA-Z][a-zA-Z0-9_.-]{1,32}@[a-z0-9_-]{2,}(\.[a-z0-9]{2,}){1,}$/.test(email)
          return validate
        }
      }
    }
  },
  methods: {
    validateEmail (value) {
      return errorMessage.errorEmail(value)
    },
    emailFormat () {
      return (!this.$v.params.email.valid || !this.$v.params.email.required) && this.invalid ? 'error' : ''
    },
    back () {
      this.$router.push('login')
    },
    resetPassword (e) {
      e.preventDefault()
      this.invalid = this.$v.$invalid
      if (this.invalid) {
        this.$v.$touch()
        return
      }
      this.$store.dispatch('allAuth/resetPassWord', {formData: this.params, modal: this.$refs['my-modal']})
    },
    emailError () {
      return this.errorEmailReset
    }
  },
  watch: {
    'params.email' () {
      this.$store.commit('allAuth/CHANGE_EMAIL', '')
    }
  },
  computed: {
    ...mapState({
      errorEmailReset: state => state.allAuth.errorEmailReset
    })
  }
}
</script>
<style scoped lang='scss'>
  @import '@/assets/stylesheet/auth/login.scss';
</style>



// WEBPACK FOOTER //
// src/views/Login/ResetPassword.vue